import Navbar from "@/components/Layout/Navbar";
import Footer from "@/components/Layout/Footer";
import SEOHead from "@/components/SEOHead";
import { Card, CardContent } from "@/components/ui/card";
import { PAGE_SEO_CONFIG } from "@/lib/seo";

const Imprint = () => {
  const seoConfig = PAGE_SEO_CONFIG.imprint;

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        titleEn={seoConfig.titleEn}
        titleDe={seoConfig.titleDe}
        descriptionEn={seoConfig.descriptionEn}
        descriptionDe={seoConfig.descriptionDe}
        keywords={seoConfig.keywords}
        path={seoConfig.path}
        breadcrumbs={[
          { name: 'Home', nameDE: 'Startseite', url: '/' },
          { name: 'Imprint', nameDE: 'Impressum', url: '/imprint' }
        ]}
      />
      
      <Navbar />
      
      <main className="pt-24 pb-32">
        <div className="container mx-auto px-6 max-w-3xl">
          <div className="text-center mb-16 pt-16">
            <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-5">Legal</div>
            <h1 className="text-5xl md:text-6xl font-semibold tracking-[-0.035em] text-balance">Imprint</h1>
          </div>

          <Card>
            <CardContent className="p-10 md:p-12 space-y-10">
              <section>
                <h2 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Company Information</h2>
                <div className="space-y-2 text-foreground/80">
                  <p><span className="text-muted-foreground">Company Name:</span> Evolvice GmbH</p>
                  <p><span className="text-muted-foreground">Address:</span> Motorstrasse 4, 70499 Stuttgart, Germany</p>
                </div>
              </section>

              <div className="border-t border-border/60" />

              <section>
                <h2 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Contact Details</h2>
                <div className="space-y-2 text-foreground/80">
                  <p><span className="text-muted-foreground">Telephone:</span> <a href="tel:+497112195590" className="hover:underline">+49 711 219 559 0</a></p>
                  <p><span className="text-muted-foreground">Fax:</span> +49 711 219 559 18</p>
                  <p><span className="text-muted-foreground">Email:</span> <a href="mailto:info@evolvice.de" className="hover:underline">info@evolvice.de</a></p>
                </div>
              </section>

              <div className="border-t border-border/60" />

              <section>
                <h2 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Legal Information</h2>
                <div className="space-y-2 text-foreground/80">
                  <p><span className="text-muted-foreground">Managing Directors:</span> Nataliia Maksymenko, Stefan Nesselhauf</p>
                  <p><span className="text-muted-foreground">Registry Court:</span> Stuttgart</p>
                  <p><span className="text-muted-foreground">Registration Number:</span> HRB 741933</p>
                  <p><span className="text-muted-foreground">VAT ID:</span> DE284128010</p>
                </div>
              </section>

              <div className="border-t border-border/60" />

              <section>
                <h2 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Responsible for Editorial Content</h2>
                <div className="space-y-1 text-foreground/80">
                  <p>Nataliia Maksymenko, Stefan Nesselhauf</p>
                  <p className="text-muted-foreground">Motorstrasse 4, 70499 Stuttgart, Germany</p>
                </div>
              </section>

              <div className="border-t border-border/60" />

              <section>
                <h2 className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">Dispute Resolution</h2>
                <p className="text-foreground/80 leading-relaxed">
                  EU Commission's online dispute resolution platform: <a href="http://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="hover:underline">http://ec.europa.eu/consumers/odr</a>
                </p>
                <p className="mt-3 text-muted-foreground leading-relaxed">
                  We are neither obliged nor willing to participate in a dispute settlement procedure at a consumer arbitration board.
                </p>
              </section>
            </CardContent>
          </Card>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Imprint;
